import React from "react";
import { NoOrders } from "../../normalizer";
import { withOrdersContainer } from "../../../containers/gamification2026";
import EmptyStateLayout from "../../shared/EmptyStateLayout";
import OrdersTable from "./OrdersTable";
import { t } from "../../../../i18n";

const Orders = (props) => {
  const { orders, ...rest } = props;

  return orders.length > 0 ? (
    <div className="orders-container">
      <OrdersTable orders={orders} {...rest} />
    </div>
  ) : (
    <EmptyStateLayout message={t("gamification2026.profile.no-orders")}>
      <div className="gl-no-store">
        <NoOrders className="mr-3 dead-grey gl-no-store__image"></NoOrders>
      </div>
    </EmptyStateLayout>
  );
};

export default withOrdersContainer(Orders);
